import { useEffect } from "react";
import "@/App.css";
import "@/i18n";
import { useTranslation } from "react-i18next";
import { MusicProvider } from "@/components/MusicContext";
import LanguageToggle from "@/components/LanguageToggle";
import MusicPlayer from "@/components/MusicPlayer";
import HeroSection from "@/components/HeroSection";
import CountdownSection from "@/components/CountdownSection";
import VenueSection from "@/components/VenueSection";
import ShabbatSection from "@/components/ShabbatSection";
import RsvpSection from "@/components/RsvpSection";
import FamilySection from "@/components/FamilySection";

function AppContent() {
  const { i18n } = useTranslation();

  useEffect(() => {
    document.documentElement.dir = i18n.language === "he" ? "rtl" : "ltr";
    document.documentElement.lang = i18n.language;
  }, [i18n.language]);

  useEffect(() => {
    const hide = () => {
      const el = document.getElementById("emergent-badge");
      if (el) { el.style.setProperty("display", "none", "important"); el.remove(); }
    };
    hide();
    const obs = new MutationObserver(hide);
    obs.observe(document.body, { childList: true, subtree: true });
    return () => obs.disconnect();
  }, []);

  return (
    <div className="app-wrapper" data-testid="app-wrapper">
      <LanguageToggle />
      <MusicPlayer />
      <HeroSection />
      <CountdownSection />
      <VenueSection />
      <ShabbatSection />
      <RsvpSection />
      <FamilySection />
    </div>
  );
}

function App() {
  return (
    <MusicProvider>
      <AppContent />
    </MusicProvider>
  );
}

export default App;
